<template>
    <div>
      <b-modal
          id="filter"
          ok-only
          centered
          size="md"
          content-class="shadow"
          hide-footer
        >
        <template #modal-title> <div style="font-size:24px; font-weight:600;">Filter</div></template>
          <div >
            <b-form-row>
              <b-col>
                <b-row class="d-flex align-items-center">
                  <b-col sm="5">
                    <p style="font-weight: 600; margin:0px;">Status Sengketa</p>
                  </b-col>:<b-col sm="6">
                      <b-form-select v-model="isSengketa" style="max-width: 478px;">
                        <b-form-select-option :value="1">Sedang Berlangsung</b-form-select-option>
                        <b-form-select-option :value="0">Selesai</b-form-select-option>
                      </b-form-select>
                  </b-col>
                </b-row>
              </b-col>
            </b-form-row>
            <div class="text-center">
              <b-button
                variant="outline-primary"
                class="mt-16 text-center mr-5"
                @click="$bvModal.hide('filter')"
              >
                Batal
              </b-button>
              <b-button
                variant="primary"
                class="mt-16 text-center"
                @click="fetchData()"
              >
                Terapkan
              </b-button>
            </div>
          </div>
      </b-modal>
      <b-row>
        <b-col cols="12">
          <!-- <b-card class="shadow" id="search-card"> -->
            <b-row>
            <b-col cols="11">
              <!-- <div class="form-row"> -->
                <div class="d-flex justify-content-between align-items-center shadow p-1 pr-3" style="background:white; border-radius:10px;">
                  <input
                    type="text"
                    class="form-control border-0"
                    v-model="search"
                    v-on:keyup.enter="fetchData()"
                    :placeholder="'Cari...'"
                  />
                  <b-button
                    size="sm"
                    style="width:80px;margin-right:10px;"
                    variant="primary"
                    @click="fetchData()"
                  >
                    <v-icon
                      style="color:white;"
                      small
                    >mdi-magnify</v-icon>
                    Cari
                  </b-button>
                </div>
                
              <!-- </div> -->
            </b-col>
            <b-col cols="1" class="d-flex align-items-center p-0">
              <b-button
                size="sm"
                variant="primary"
                @click="showFilter()"
              >
                <v-icon
                  style="color:white;"
                  small
                >mdi-filter</v-icon>
                Filter
              </b-button>
            </b-col>
          </b-row>
          <!-- </b-card> -->
        </b-col>
      </b-row>

      <b-row class="mt-5">
        <b-col class="d-flex align-items-center justify-content-between">
          <span style="font-size:16px; font-weight:bold;">Pembekuan Ormas</span>
        </b-col>
      </b-row>
       <div
            class="table-responsive mt-4"
            style="border-radius:15px;"
          >
            <table
              class="
            table
            table-head-custom
            table-vertical-center
            table-head-bg
            table-bordered
          "
              style="font-size:14px !important;"
            >
              <thead>
                <tr class="text-left">
                  <th style="width: 20px" class="text-capitalize">No.</th>
                  <th style="min-width: 50px" class="text-capitalize">Nama Ormas</th>
                  <th style="min-width: 50px" class="text-capitalize">Singkatan</th>
                  <th style="min-width: 50px" class="text-capitalize">Status Sekretariat</th>
                  <th style="min-width: 50px" class="text-capitalize">Status Sengketa</th>
                  <th style="min-width: 50px" class="text-capitalize">Pembekuan</th>
                  <!-- <th style="min-width: 50px" class="text-capitalize">Buka Pembekuan</th> -->
                </tr>
              </thead>
              <!-- <tbody v-if="list.length == 0">
                  <template>
                      <tr>
                          <td colspan="6"> -- Tidak ada permohonan -- </td>
                      </tr>
                  </template>
              </tbody> -->
              <tbody style="background: #FFFFFF;">
                <template v-for="(item, i) in listSengketa">
                  <tr v-bind:key="i">
                    <td >
                      <span class="
                      text-dark-75
                      font-weight-bolder
                      d-block
                      font-size-lg
                    ">{{ (i+1) + ((currentPage-1)*perPage)}}</span>
                    </td>
                    <td class="text-left">
                      <span  class="
                      text-dark-75
                      font-weight-bolder
                      text-left
                      font-size-lg
                    "> {{ item.namaOrmas}}
                      </span>
                    </td>
                    <td class="text-left">
                      <span class="
                      text-dark-75
                      font-weight-bolder
                      d-block
                      text-left
                      font-size-lg
                    ">{{ item.namaSingkat}}</span>
                    </td>
                    <td class="text-left">
                      <span class="
                      text-dark-75
                      font-weight-bolder
                      d-block
                      text-left
                      font-size-lg
                    ">{{item.masterLokasiSekretariat.nama_lokasi}}</span>
                    </td>
                    <td class="text-left">
                      <span class="
                      text-dark-75
                      font-weight-bolder
                      d-block
                      text-left
                      font-size-lg
                    ">-</span>
                    </td>
                    <td class="text-left">
                      <span class="
                      text-dark-75
                      font-weight-bolder
                      d-block
                      text-center
                      font-size-lg
                    ">
                    <b-form-checkbox @change="changeStatus(item.user.id, item.user.status)" v-model="item.user.status" value="0" unchecked-value="1" name="check-button" switch>
                      <!-- {{ checked ? 'Buka Pembekuan' : 'Bekukan'}} -->
                    </b-form-checkbox>
                    </span>
                    </td>
                    <!-- <td class="text-left">
                      <span class="
                      text-dark-75
                      font-weight-bolder
                      d-block
                      text-center
                      font-size-lg
                    "><b-form-checkbox></b-form-checkbox></span>
                    </td> -->
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
          <b-row>
            <b-col class="d-flex justify-content-end">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                aria-controls="my-table"
              ></b-pagination>
            </b-col>
          </b-row>
    </div>
</template>
<style>
#search-card .card-body {
  padding:0px !important;
}
</style>
<script>
import Swal from "sweetalert2";
  // import { ModelSelect } from 'vue-search-select'

export default {
  name: "Sengketa",
  // components: {
  //     ModelSelect
  // },
  data() {
    return {
      checked: false,
      options: [],
      createMode: true,
      currentPage: 1,
      currentOffset: 0,
      perPage: 20,
      totalRows: 0,
      search: '',
      isSengketa: '',
      listSengketa: [],
      form: {
        "sumber_laporan": '',
        "keterangan": '',
        "status_sengketa": 0,
        "tanggal_sengketa": '',
        "data_ormas_id": ''
      },
      id: null,
      listOrmas: [],
      filter: {
        status_sengketa: null,
        tanggal_sengketa: ''
      },
      filterStatus: false
    }
  },
  mounted(){
    this.fetchData()
  }, 
  watch:{
    currentPage(to){
      this.currentOffset = to - 1
      this.fetchData()
    },
    search: {
      handler() {
        // Check if the user has stopped typing
        if (this.typingTimeout) {
          clearTimeout(this.typingTimeout);
        }
        this.typingTimeout = setTimeout(() => {
          // User has stopped typing, perform your action here
          this.fetchData()

        }, 500); // Adjust the delay as needed (1 second in this example)
      },
      immediate: false, // Set to true if you want to trigger it immediately
    }
  },
  methods: {
    showFilter(){
      this.filterStatus = false
      this.$bvModal.show('filter')
    },
    fetchData(){
      let query = {
        offset: this.currentOffset
      }

      if(this.search !== '') query.search = this.search
      if(this.isSengketa !== '') query.sengketa = this.isSengketa

      if (this.search.length > 0 && this.search.length < 3) return;

      this.$store
      .dispatch("listPembekuanCount", query)
      .then((res) => {
        this.totalRows = res.data.count
      })
      this.$store
      .dispatch("listPembekuan", query)
      .then((res) => {
        this.listSengketa = res.data.data
        this.$bvModal.hide('filter')
      })
    },
    changeStatus(id, status){
      var isActive = status == 1 ? true : false
      this.$store
      .dispatch("deactivateUser", {id: id, isActive: isActive})
      .then((res) => {
        if(res.data.status){
        Swal.fire({
            title: res.data.data.status == 1 ? "Berhasil mengaktifkan user" : 'Pembekuan user berhasil',
            text: "",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Ok",
          })
        }
      })
    }
  }
}
</script>